// @copyright  2006-2022 West Indies Software Engineering Company Limited. All rights reserved.

export default [
    {
        path: 'tenant-payroll-settings',
        component: () =>
            import('@/pages/[organisation]/system/tenant-payroll-settings/index.vue'),
        name: 'system.tenant-payroll-settings.update-tenant-payroll-settings',
        meta: {
            loginRequired: true,
            permission: 'access.system.tenant.update-tenant-payroll-settings',
        },
    },
];
